module.exports = __webpack_public_path__ + "static/media/oracle.c918412b.png";